"use client";

import { useTheme } from "next-themes";
import { Toaster as SonnerToaster } from "sonner";

export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <SonnerToaster
      theme={resolvedTheme === "light" ? "light" : "dark"}
      position="bottom-right"
      richColors={false}
      toastOptions={{
        className: "text-sm",
        style: {
          background: "rgb(var(--bg-elevated))",
          border: "1px solid rgb(var(--tone) / 0.10)",
          color: "rgb(var(--text-primary))",
        },
      }}
    />
  );
}
